<div id="header">
  <mat-form-field>
    <mat-label>Recherche</mat-label>
    <input #filter matInput placeholder="Saisir la recherche" [formControl]="inputControl" minlength={{minLength()}} 
      (keypress)="onKeyPress($event)">
    <mat-icon matSuffix>search</mat-icon>
    <mat-error *ngIf="inputControl.hasError('minlength')">Min. 3 caractères</mat-error>
  </mat-form-field>
  <div id="order-type" class="items-center ml-5">
    Rechercher par
    <mat-radio-group [formControl]="radioControl" class="flex">
      <mat-radio-button value="nom">Nom</mat-radio-button>
      <mat-radio-button value="casier">N° de casier</mat-radio-button>
      <mat-radio-button value="porteur">N° d'utilisateur</mat-radio-button>
    </mat-radio-group>
  </div>
  <button mat-raised-button routerLink="../add-porteur" id="button">Ajouter un utilisateur</button>
</div>
<section>
  <p id="infosRecherche">{{ labelSiVide }}</p>
  <mat-grid-list [cols]="breakpoint" rowHeight="1.35:1" gutterSize="20px" (window:resize)="onResize($event.target.innerWidth)">
    <mat-grid-tile *ngFor="let port of porteurs">
      <app-porteur [porteur]="port">
      </app-porteur>
    </mat-grid-tile>
  </mat-grid-list>
</section>